import styled from 'styled-components'
import { Breadcrumb } from "antd"

export const Container = styled.div`
    padding: 15px 30px;
    height: 100%;
    background-color: ${props => props.theme.colors.subHeaderBg};
`

export const Xbreadcrumb = styled(Breadcrumb)`
    .ant-breadcrumb-link a, .ant-breadcrumb-link,.ant-breadcrumb-separator {
        color: white !important;
    }
`

export const Title = styled.h1`
    margin: 0;
    color: white;
    font-size: 24px;
    font-weight: bold;
`